module.exports = __webpack_public_path__ + "static/media/calculus-i-enrolled.32497a24.svg";